module.exports = __webpack_public_path__ + "img/AUX-icon.e89d5127.png";